import { type ImageErrorEventData, type ImageSourcePropType, type NativeSyntheticEvent } from 'react-native';

export const ImageCarousel = () => {
  return null;
};

export type ImageSourceAndLabel = {
  source: ImageSourcePropType;
  accessibilityLabel?: string;
};

export type ImageCarouselProps = {
  images: ImageSourceAndLabel[];
  width: number;
  index?: number;
  onClick?: (index: number) => void;
  onChange?: (index: number) => void;
  onError?: (error: NativeSyntheticEvent<ImageErrorEventData>) => void;
  pixelSize?: number;
};
